export {
  default,
  initialize,
} from 'active-model-adapter/initializers/active-model-adapter';
